<template>
  <div class="nch--blog-tag">
    <div class="nch--blog-container">
      <Card class="nch--blog-content">
        <Breadcrumb :items="breadcrumb" />
        <Header :value="tag"></Header>
        <Posts :value="tag" />
      </Card>
      <Aside/>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../../common/Breadcrumb';
import Card from '../../common/Card';
import Aside from '../../Aside';
import Posts from './Posts';
import Header from './Header';
import theme from '../../../mixins/theme';

export default {
  name: 'Tag',
  components: {
    Card,
    Breadcrumb,
    Aside,
    Posts,
    Header,
  },
  mixins: [
    theme,
  ],
  props: {
    value: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      default: () => ({
        title: 'Blog',
      }),
    },
  },
  data() {
    return {
      breadcrumb: [
        { name: this.settings.title, href: '/blog' },
      ],
    };
  },
  computed: {
    tag() {
      return this.value;
    },
  },
};
</script>
<style scoped>
.nch--blog-tag{
  display: flex;
  align-items: center;
  justify-content: center;
}
.nch--blog-container {
  display: grid;
  width: var(--blog-container-width);
  grid-template-columns: 1fr auto;
  grid-template-areas: "content aside";
}
.nch--blog-content{
  display: flex;
  flex-direction: column;
}
@media (max-width: 900px) {
  .nch--blog-container {
    display: flex;
    flex-direction: column;
  }
}
</style>
<style>
.nch--blog-tag * {
  font-family: var(--blog-font-family);
}
</style>
